import { combineReducers } from 'redux';
import apidocs from './apidocs';
import connectors from './connectors';
import components from './components';
import configuration from './configuration';
import credentials from './credentials';
import flows from './flows';
import models from './models';
import navigation from './navigation';
import restart from '../widgets/Restart';
import summary from './summary';
import schema from './schema';
import system from './system';
import triggers from './triggers';
import updates from './updates';

const initialState = {
	location: null,
	prevLocation: null
};

export const location = (state, action) => {
	state = state || initialState;
	if (action.type === 'SET_LOCATION') {
		return {
			...state,
			location: action.payload,
			prevLocation: state.location
		};
	}
	return state;
};

export default combineReducers({
	location,
	...apidocs.reducers,
	...configuration.reducers,
	...connectors.reducers,
	...components.reducers,
	...credentials.reducers,
	...flows.reducers,
	...models.reducers,
	...navigation.reducers,
	...restart.reducers,
	...schema.reducers,
	...summary.reducers,
	...system.reducers,
	...triggers.reducers,
	...updates.reducers
});
